import { nriOfferData, nriWhatsappUrl } from "../../data/nriTaxData";
import { Check, ArrowRight } from "lucide-react";

const shortBullets = [
  { label: "Residency classification", detail: "NRI, RNOR or Resident — written, with legal basis" },
  { label: "DTAA benefit status", detail: "Missed claims + estimated refund value" },
  { label: "Schedule FA position", detail: "Foreign asset exposure or ₹10L+ penalty risk" },
  { label: "Prior-year recovery", detail: "Revised return opportunity — quantified in ₹" },
  { label: "Full ITR filed", detail: "Correct form, every exemption, every treaty claim" },
];

export const NriOfferSection = () => (
  <section id="nri-offer" className="relative py-28" style={{ background: "#1a1c1b" }}>
    <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />
    <div className="max-w-[87.5rem] mx-auto px-10">

      {/* Heading */}
      <div className="mb-14">
        <span className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {nriOfferData.sectionLabel}
        </span>
        <p className="text-[#888680]/60 font-semibold uppercase mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(0.85rem, 0.7rem + 0.6vw, 1rem)", letterSpacing: "-0.01em" }}>
          Introducing
        </p>
        <h2 className="font-black uppercase leading-tight" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3.5rem)", letterSpacing: "-0.03em" }}>
          <span className="text-[#d9fb06]">NRI Tax</span>
          <br />
          <span className="text-[#dfddd6]">Position Report</span>
        </h2>
        <p className="text-[#888680]/60 text-sm mt-2 italic" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>Not a standard ITR filing. A complete diagnostic.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        {/* Left — bullets */}
        <div>
          <p className="text-[#888680] text-sm mb-5 font-medium" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            In <span className="text-[#d9fb06] font-black">48 hours</span>, you will know:
          </p>
          <div className="flex flex-col gap-3 mb-10">
            {shortBullets.map((b, i) => (
              <div key={i} className="flex items-start gap-3 bg-[#302f2c]/30 border border-[#3f4816]/10 rounded-sm px-4 py-3">
                <div className="flex-shrink-0 mt-0.5 w-5 h-5 rounded bg-[#d9fb06]/10 border border-[#d9fb06]/20 flex items-center justify-center">
                  <Check size={11} className="text-[#d9fb06]" />
                </div>
                <div>
                  <p className="text-[#dfddd6] font-bold text-sm" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{b.label}</p>
                  <p className="text-[#888680] text-xs mt-0.5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{b.detail}</p>
                </div>
              </div>
            ))}
          </div>
          <a href={nriWhatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="nri-offer-cta"
            className="group inline-flex items-center gap-2 bg-[#d9fb06] text-[#1a1c1b] font-bold text-sm px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 uppercase tracking-tight"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            Get My NRI Tax Report + Filing
            <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5 duration-300" />
          </a>
        </div>

        {/* Right — conviction box */}
        <div className="bg-[#302f2c]/50 border border-[#d9fb06]/15 rounded-sm p-10 text-center">
          <div className="w-12 h-12 rounded-full bg-[#d9fb06]/10 border border-[#d9fb06]/20 flex items-center justify-center mx-auto mb-7">
            <Check size={22} className="text-[#d9fb06]" />
          </div>
          <p className="text-[#888680]/50 text-xs uppercase tracking-widest mb-2" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>You are not buying</p>
          <p className="text-[#888680] font-black uppercase mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1rem, 0.85rem + 0.8vw, 1.4rem)", letterSpacing: "-0.02em" }}>an ITR filing.</p>
          <div className="h-px bg-[#3f4816]/20 mb-5" />
          <p className="text-[#888680]/50 text-xs uppercase tracking-widest mb-2" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>You are buying</p>
          <p className="text-[#dfddd6] font-black uppercase leading-tight" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.2rem, 1rem + 1.2vw, 1.8rem)", letterSpacing: "-0.03em" }}>
            Certainty that <span className="text-[#d9fb06]">India cannot</span><br />come after you.
          </p>
          <div className="mt-7 pt-5 border-t border-[#3f4816]/20">
            <p className="text-[#888680] text-xs uppercase tracking-widest mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>Delivered in</p>
            <p className="text-[#d9fb06] font-black" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(2rem, 1.6rem + 1.5vw, 3rem)", letterSpacing: "-0.04em" }}>48 Hours</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
